<template>
  <div
    ref="selectRef"
    class="relative w-fit min-w-[200px] select-none text-[14px]"
  >
    <button
      type="button"
      class="bg-white flex h-[38px] w-full items-center justify-between gap-2 rounded-lg border border-[#E9E9E9] px-3 transition-colors hover:border-[#D9D9D9]"
      @click="isOpen = !isOpen"
    >
      <span class="truncate text-left text-new-card--title-black">
        {{ label }}:
        <span class="font-medium text-new-test-black">{{ currentLabel }}</span>
      </span>
      <svg
        class="size-4 text-new-gray-dark transition-transform duration-200"
        :class="{ 'rotate-180': isOpen }"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
      >
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2"
          d="M19 9l-7 7-7-7"
        />
      </svg>
    </button>

    <div
      v-if="isOpen"
      class="shadow-lg absolute left-0 z-50 mt-1 max-h-60 w-full overflow-y-auto rounded-lg border border-[#E9E9E9] bg-white-100 p-2"
    >
      <button
        v-for="option in options"
        :key="option.value"
        type="button"
        class="mb-0.5 block w-full rounded px-3 py-2 text-left transition-colors last:mb-0 hover:bg-[#D9D9D9]"
        :class="{
          'bg-[#D9D9D9]/50': String(modelValue) === String(option.value),
        }"
        @click="selectOption(option.value)"
      >
        {{ option.label }}
      </button>
    </div>
  </div>
</template>

<script setup>
const modelValue = defineModel({ type: [String, Number], required: true });

const props = defineProps({
  label: { type: String, required: true }, // 'Рубрика'
  options: { type: Array, required: true }, // [{ label: '...', value: '...' }]
});

const isOpen = ref(false);
const selectRef = ref(null);

const currentLabel = computed(() => {
  if (modelValue.value === undefined || modelValue.value === null) return '';

  const found = props.options.find(
    (opt) => String(opt.value) === String(modelValue.value),
  );

  return found ? found.label : '';
});
const selectOption = (value) => {
  modelValue.value = value;
  isOpen.value = false;
};

const handleClickOutside = (event) => {
  if (selectRef.value && !selectRef.value.contains(event.target)) {
    isOpen.value = false;
  }
};

onMounted(() => document.addEventListener('click', handleClickOutside));
onUnmounted(() => document.removeEventListener('click', handleClickOutside));
</script>
